"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PinterestNoScript = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const PinterestNoScript = () => {
    return ((0, jsx_runtime_1.jsx)("noscript", { children: (0, jsx_runtime_1.jsx)("img", { height: "1", width: "1", style: { display: 'none' }, alt: "", src: "https://ct.pinterest.com/v3/?event=init&tid=2613487462818&pd[em]=<hashed_email_address>&noscript=1" }) }));
};
exports.PinterestNoScript = PinterestNoScript;
